import React, { useContext } from "react";
import Cookies from "universal-cookie";
import { ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from "@material-ui/core/CssBaseline";
import Container from "@material-ui/core/Container";
import { theme } from "../../layout/theme";
import { AppContext } from "store/AppContext";
import { Button } from "@material-ui/core";


const AccessDenied = () => {
    const cookies = new Cookies();
    const context = useContext(AppContext);

    const logout = async () => {
        //cookies.remove("accesstoken");
        const idtoken = cookies.get("id_token_hint");
        await fetch('api/auth/logout', {
            method: 'GET',
        }).then((response) => { console.log(response) }).catch((e) => { console.log("error on logout: " + e) });

        cookies.remove("jwt_token");
        cookies.remove("id_token_hint");

        context.isLoggedIn.set(false);
        const fullLogoutUrl = `${process.env.REACT_APP_IDP_LOGOUT_URL}?post_logout_redirect_uri=${process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI}&id_token_hint=${idtoken}`;
        window.location.href = fullLogoutUrl;
    }

    return <ThemeProvider theme={theme}>
        <CssBaseline />
        <Container style={{ marginTop: "100px" }}>
            <span style={{ color: "#555", fontWeight: "bold" }}>403</span>
            <h1 style={{ fontSize: 24, fontWeight: "bold", margin: "4px 0 12px" }}>Aðgangur bannaður</h1>
            <p style={{ marginBottom: 48 }}>Þú hefur ekki réttindi til þess að skoða þessa síðu.</p>
            <Button type="button" variant="outlined" onClick={logout}>Útskrá</Button>
        </Container>
    </ThemeProvider>
}
    



export default AccessDenied;